
































import { Vue, Component, Prop } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";

@Component({
  components: {
    "cprod-providers-wrapper": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvidersWrapper.vue"
      ),
    "cprod-tabigation": () =>
      import("@/components/app/global/contractProducts/cProdTabigation.vue"),
    "cprod-condition-notif": () =>
      import(
        "@/components/app/global/contractProducts/cProdConditionNotif.vue"
      ),
    "cprod-billboard": () =>
      import(
        "@/components/app/global/contractProducts/cProdClientBillboard.vue"
      ),
    "cprod-prov-key-actions-component": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvKeyActionsComp.vue"
      ),
    "cprod-details-list-component": () =>
      import(
        `@/components/app/global/contractProducts/cProdDetailsListComp.vue`
      ),
    "cprod-about-component": () =>
      import(`@/components/app/global/contractProducts/cProdAboutComp.vue`),
    "cprod-assistance-component": () =>
      import(`@/components/app/global/contractProducts/cProdAssistanceComp.vue`)
  }
})
export default class CProdClientLayout extends Vue {
  @Prop({ default: () => [] })
  public routes!: (vm: CProdClientLayout & any) => IMenuRoute[];

  // Life-cycle methods

  private created() {
    this.$bus.$on("scrollClientCProdView", this.scrollClientCProdView);
  }

  private beforeDestroy() {
    this.$bus.$off("scrollClientCProdView", this.scrollClientCProdView);
  }

  // Methods

  public scrollClientCProdView() {
    const offset = this.$store.getters["ui/isTabletPlus"] ? 125 : 136;
    const { y, top } = document
      ?.getElementsByClassName("u-client-cprod-primary")[0]
      ?.getBoundingClientRect();
    const targetY = top + window.scrollY - offset;
    if (y - offset < 0) window.scrollTo(0, targetY);
  }
}
